import axios from "axios"

export default {
    actions: {
        loadCep(context, cep) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`https://brasilapi.com.br/api/cep/v1/${cep}`, { withCredentials: false })
                    .then(response => {
                        const data = response.data;
                        
                        // Mapeando os campos da BrasilAPI para o padrão ViaCEP
                        const formattedData = {
                            cep: data.cep,
                            logradouro: data.street, // BrasilAPI 'street' -> ViaCEP 'logradouro'
                            complemento: data.complement || "", 
                            bairro: data.neighborhood, // BrasilAPI 'neighborhood' -> ViaCEP 'bairro'
                            localidade: data.city,     // BrasilAPI 'city' -> ViaCEP 'localidade'
                            uf: data.state,            // BrasilAPI 'state' -> ViaCEP 'uf'
                            ibge: data.service === 'correios' ? data.city_code : null // Opcional
                        };

                        resolve(formattedData);
                    })
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
        
        loadCepLegacy(context, cep) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`https://viacep.com.br/ws/` + cep + `/json?_=${Date.now()}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
    },

    getters: {

    }

}
